import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalModule, Modal as BaseModal } from 'angular2-modal';

import { Modal } from './modal';
import { DialogFormModal, FormDropIn, VEXDialogButtons } from './dialog-form-modal';

export const /** @type {?} */ providers: any[] = [
  { provide: BaseModal, useClass: Modal },
  { provide: Modal, useClass: Modal }
];
export class VexModalModule {
/**
 * @return {?}
 */
static getProviders(): any[] {
    return providers;
  }

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [ ModalModule, CommonModule ],
  declarations: [
    VEXDialogButtons,
    FormDropIn,
    DialogFormModal
  ],
  providers,
  entryComponents: [
    DialogFormModal,
    FormDropIn
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function VexModalModule_tsickle_Closure_declarations() {
/** @type {?} */
VexModalModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VexModalModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
